// extracted by mini-css-extract-plugin
export var contentBox = "Differentials-module--content-box--6fcb9";
export var core = "Differentials-module--core--42027";